<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(100%); /* 起始位置：向左偏移100% */
    opacity: 0; /* 可选：淡入效果 */
  }
  100% {
    transform: translateX(0); /* 结束位置：回到原位 */
    opacity: 1;
  }
}

.slide-element {
  animation: slideInFromLeft 1s ease-out forwards; /* 动画名称、时长、速度曲线、保持结束状态 */
}

.strong-img {
  transition: transform 0.4s ease-out; /* 平滑过渡 */
}

/* 鼠标悬停时上浮10px */
.strong-img:hover {
  transform: translateY(-10px);
}
</style>
